(function () {
  const qs = (sel, root) => (root || document).querySelector(sel);
  const qsa = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  const IMAGE_WIDTHS = [352, 832, 1200, 1400];
  const SIZE_RANK = {
    xxs: 0,
    '2xs': 0,
    xs: 1,
    'extra small': 1,
    'x-small': 1,
    s: 2,
    small: 2,
    m: 3,
    medium: 3,
    l: 4,
    large: 4,
    xl: 5,
    'extra large': 5,
    'x-large': 5,
    '1xl': 5,
    xxl: 6,
    '2xl': 6,
    'extra extra large': 6,
    xxxl: 7,
    '3xl': 7,
    '4xl': 8,
    xxxxl: 8,
    '5xl': 9
  };

  function trapToggle(btn, panel, open) {
    if (!btn || !panel) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      panel.hidden = false;
      const focusable = qs('a, button, input, select, textarea', panel);
      if (focusable) focusable.focus();
    } else {
      panel.hidden = true;
      btn.focus();
    }
  }

  const menuBtn = qs('[data-menu-toggle]');
  const drawer = qs('[data-drawer]');
  if (menuBtn && drawer) {
    menuBtn.addEventListener('click', () => trapToggle(menuBtn, drawer, drawer.hidden));
    const close = qs('[data-drawer-close]', drawer);
    if (close) close.addEventListener('click', () => trapToggle(menuBtn, drawer, false));
    const backdrop = qs('[data-drawer-backdrop]', drawer);
    if (backdrop) backdrop.addEventListener('click', () => trapToggle(menuBtn, drawer, false));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !drawer.hidden) trapToggle(menuBtn, drawer, false);
    });
  }

  const searchBtn = qs('[data-search-toggle]');
  const searchPanel = qs('[data-search-panel]');
  if (searchBtn && searchPanel) {
    searchBtn.addEventListener('click', () => {
      const open = searchPanel.hidden;
      trapToggle(searchBtn, searchPanel, open);
    });
  }

  function withWidth(url, width) {
    if (!url) return '';
    const raw = String(url);
    if (/([?&])width=\d+/i.test(raw)) {
      return raw.replace(/([?&])width=\d+/i, '$1width=' + width);
    }
    return raw + (raw.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  function srcsetFrom(url) {
    return IMAGE_WIDTHS.map((w) => withWidth(url, w) + ' ' + w + 'w').join(', ');
  }

  function isColorOptionName(name) {
    const n = (name || '').toLowerCase();
    return n === 'color' || n === 'colour' || n === 'colors' || n === 'colours';
  }

  function isSizeOptionName(name) {
    const n = (name || '').toLowerCase();
    return n === 'size' || n === 'sizes';
  }

  function colorOptionIndex(form) {
    const fieldsets = qsa('[data-option]', form);
    return fieldsets.findIndex((fs) => isColorOptionName(fs.getAttribute('data-option-name')));
  }

  function sizeOptionIndex(form) {
    const fieldsets = qsa('[data-option]', form);
    return fieldsets.findIndex((fs) => isSizeOptionName(fs.getAttribute('data-option-name')));
  }

  function normalizeSize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function isLargeSize(value) {
    const n = normalizeSize(value);
    return n === 'l' || n === 'large';
  }

  function sizeRank(value) {
    const n = normalizeSize(value);
    return Object.prototype.hasOwnProperty.call(SIZE_RANK, n) ? SIZE_RANK[n] : 50;
  }

  function mediaIdKey(id) {
    if (id == null || id === '') return '';
    return String(id).split('/').pop();
  }

  function variantMediaId(variant) {
    if (!variant) return '';
    const fm = variant.featured_media;
    if (fm && fm.id != null) return mediaIdKey(fm.id);
    return '';
  }

  function variantMediaList(variant) {
    if (!variant) return [];
    const media = variant.media;
    if (Array.isArray(media)) return media;
    if (media && Array.isArray(media.nodes)) return media.nodes;
    return [];
  }

  function variantOwnsMediaId(variant, wanted) {
    if (!variant || !wanted) return false;
    if (variantMediaId(variant) === wanted) return true;
    const list = variantMediaList(variant);
    for (let i = 0; i < list.length; i++) {
      if (mediaIdKey(list[i] && list[i].id) === wanted) return true;
    }
    return false;
  }

  function colorFromAltText(alt, colorValues) {
    const text = String(alt || '').toLowerCase();
    if (!text || !colorValues || !colorValues.length) return '';
    for (let i = 0; i < colorValues.length; i++) {
      const color = colorValues[i];
      const needle = String(color || '').trim().toLowerCase();
      if (!needle) continue;
      const escaped = needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
      const re = new RegExp('(?:^|[^a-z0-9])' + escaped + '(?:$|[^a-z0-9])', 'i');
      if (re.test(text)) return color;
    }
    return '';
  }

  function mediaFromVariant(variant, product) {
    if (!variant) return null;
    const fm = variant.featured_media;
    if (fm) {
      const preview = fm.preview_image || {};
      const src = preview.src || fm.src;
      if (src) {
        return {
          src: src,
          alt: fm.alt || (variant.featured_image && variant.featured_image.alt) || (product && product.title) || '',
          id: fm.id != null ? mediaIdKey(fm.id) : ''
        };
      }
    }
    const fi = variant.featured_image;
    if (fi && fi.src) {
      return {
        src: fi.src,
        alt: fi.alt || (product && product.title) || '',
        id: fi.id != null ? mediaIdKey(fi.id) : ''
      };
    }
    return null;
  }

  function setMainImage(root, url, alt, mediaId) {
    const wrap = qs('[data-main-media]', root);
    if (!wrap || !url) return;
    let img = qs('img', wrap);
    if (!img) {
      img = document.createElement('img');
      img.loading = 'eager';
      wrap.textContent = '';
      wrap.appendChild(img);
    }
    const src = withWidth(url, 1400);
    img.removeAttribute('srcset');
    img.setAttribute('sizes', '(min-width: 800px) 50vw, 100vw');
    img.src = src;
    img.setAttribute('srcset', srcsetFrom(url));
    img.alt = alt || '';
    img.setAttribute('width', '1400');
    if (mediaId) wrap.setAttribute('data-media-id', String(mediaId));

    const thumbs = qsa('[data-thumb]', root);
    let matched = false;
    thumbs.forEach((btn) => {
      const match = mediaId && String(btn.getAttribute('data-media-id') || '') === String(mediaId);
      btn.setAttribute('aria-current', match ? 'true' : 'false');
      btn.tabIndex = match ? 0 : -1;
      if (match) matched = true;
    });
    if (!matched && thumbs.length) thumbs[0].tabIndex = 0;
  }

  function activateThumb(root, btn) {
    if (!btn) return;
    const src = btn.getAttribute('data-full') || '';
    const srcset = btn.getAttribute('data-srcset') || '';
    const alt = btn.getAttribute('data-alt') || '';
    const mediaId = btn.getAttribute('data-media-id') || '';
    const wrap = qs('[data-main-media]', root);
    const img = wrap ? qs('img', wrap) : null;
    if (img && src) {
      img.removeAttribute('srcset');
      img.src = src;
      if (srcset) {
        img.setAttribute('srcset', srcset);
      } else {
        img.setAttribute('srcset', srcsetFrom(src));
      }
      img.setAttribute('sizes', '(min-width: 800px) 50vw, 100vw');
      img.alt = alt;
    }
    if (wrap && mediaId) wrap.setAttribute('data-media-id', mediaId);
    qsa('[data-thumb]', root).forEach((b) => {
      const on = b === btn;
      b.setAttribute('aria-current', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
  }

  qsa('[data-product]').forEach((root) => {
    const form = qs('[data-product-form]', root);
    const jsonEl = qs('[data-product-json]', root);
    const thumbs = qsa('[data-thumb]', root);
    let product = null;
    if (jsonEl) {
      try {
        product = JSON.parse(jsonEl.textContent);
      } catch (err) {
        product = null;
      }
    }

    const idInput = form ? qs('[name="id"]', form) : null;
    const priceEl = qs('[data-price]', root);
    const atc = form ? qs('[type="submit"]', form) : null;
    const atcLabel = atc ? atc.textContent : '';

    function selectedOptions() {
      if (!form) return [];
      return qsa('[data-option]', form).map((fieldset) => {
        const checked = qs('input:checked', fieldset);
        return checked ? checked.value : '';
      });
    }

    function setOptionValue(optionIndex, value) {
      if (!form || optionIndex < 0 || value == null || value === '') return false;
      const fieldsets = qsa('[data-option]', form);
      const fieldset = fieldsets[optionIndex];
      if (!fieldset) return false;
      const input = qsa('input', fieldset).find((el) => el.value === String(value));
      if (!input) return false;
      input.checked = true;
      return true;
    }

    function findVariant() {
      if (!product) return null;
      const opts = selectedOptions();
      return (product.variants || []).find((v) =>
        opts.every((opt, i) => String(v.options[i]) === String(opt))
      );
    }

    function findColorVariant() {
      if (!product || !form) return null;
      const opts = selectedOptions();
      const colorI = colorOptionIndex(form);
      if (colorI < 0 || !opts[colorI]) return null;
      const colorVal = String(opts[colorI]);
      const variants = product.variants || [];
      return (
        variants.find((v) => String(v.options[colorI]) === colorVal && (v.featured_media || v.featured_image)) ||
        variants.find((v) => String(v.options[colorI]) === colorVal)
      );
    }

    function variantsForColor(colorVal) {
      if (!product) return [];
      const colorI = form ? colorOptionIndex(form) : -1;
      const variants = product.variants || [];
      if (colorI < 0 || colorVal == null || colorVal === '') return variants;
      return variants.filter((v) => String(v.options[colorI]) === String(colorVal));
    }

    function pickSizeForColor(colorVal, currentSize) {
      if (!form) return currentSize;
      const sizeI = sizeOptionIndex(form);
      if (sizeI < 0) return currentSize;
      const variants = variantsForColor(colorVal);
      const sizes = [];
      const seen = new Set();
      variants.forEach((v) => {
        const value = String(v.options[sizeI] || '');
        if (!value || seen.has(value)) return;
        seen.add(value);
        sizes.push({ value: value, available: !!v.available });
      });
      if (!sizes.length) return currentSize;
      if (currentSize && sizes.some((s) => s.value === currentSize)) return currentSize;
      const large = sizes.find((s) => isLargeSize(s.value));
      if (large) return large.value;
      const curRank = sizeRank(currentSize);
      const larger = sizes
        .filter((s) => sizeRank(s.value) > curRank)
        .sort((a, b) => sizeRank(a.value) - sizeRank(b.value));
      if (larger.length) return larger[0].value;
      const instock = sizes.find((s) => s.available);
      return (instock || sizes[0]).value;
    }

    function ensureSizeForSelectedColor() {
      if (!form) return;
      const sizeI = sizeOptionIndex(form);
      if (sizeI < 0) return;
      const colorI = colorOptionIndex(form);
      const opts = selectedOptions();
      const colorVal = colorI >= 0 ? opts[colorI] : '';
      const next = pickSizeForColor(colorVal, opts[sizeI]);
      if (next && next !== opts[sizeI]) setOptionValue(sizeI, next);
    }

    function colorOptionValues() {
      const colorI = colorOptionIndex(form);
      if (colorI < 0) return [];
      const seen = {};
      const values = [];
      (product.variants || []).forEach((v) => {
        const c = String(v.options[colorI] || '');
        if (c && !seen[c]) {
          seen[c] = true;
          values.push(c);
        }
      });
      values.sort((a, b) => b.length - a.length);
      return values;
    }

    function altForMediaId(wanted) {
      if (!wanted) return '';
      const mediaList = product.media || [];
      for (let i = 0; i < mediaList.length; i++) {
        const m = mediaList[i];
        if (mediaIdKey(m && m.id) === wanted) {
          return (m && (m.alt || (m.preview_image && m.preview_image.alt))) || '';
        }
      }
      return '';
    }

    function colorFromMediaId(mediaId, altHint) {
      if (!product || !form) return '';
      const colorI = colorOptionIndex(form);
      if (colorI < 0) return '';
      const wanted = mediaIdKey(mediaId);
      const variants = product.variants || [];
      if (wanted) {
        for (let i = 0; i < variants.length; i++) {
          const v = variants[i];
          if (variantOwnsMediaId(v, wanted)) return String(v.options[colorI]);
        }
      }
      const alt = altHint || altForMediaId(wanted);
      return colorFromAltText(alt, colorOptionValues());
    }

    function selectColorFromThumb(btn) {
      if (!form || !product || !btn) return;
      const colorI = colorOptionIndex(form);
      if (colorI < 0) return;
      const mediaId = btn.getAttribute('data-media-id') || '';
      const alt = btn.getAttribute('data-alt') || '';
      const colorVal = colorFromMediaId(mediaId, alt);
      if (!colorVal) return;
      setOptionValue(colorI, colorVal);
      ensureSizeForSelectedColor();
      syncVariantState(false);
    }

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.themeMoneyFormat);
      }
      return (cents / 100).toFixed(2);
    }

    function syncVariantState(updateImage) {
      if (!form) return;
      qsa('[data-option]', form).forEach((fieldset) => {
        const checked = qs('input:checked', fieldset);
        const label = qs('[data-option-value]', fieldset);
        if (checked && label) label.textContent = checked.value;
      });
      const variant = findVariant();
      const mediaVariant = variant || findColorVariant();
      if (!variant) {
        if (idInput) idInput.value = '';
        if (atc) {
          atc.disabled = true;
          atc.textContent = atc.dataset.unavailable || atcLabel;
        }
      } else {
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.innerHTML = formatMoney(variant.price);
        if (atc) {
          atc.disabled = !variant.available;
          atc.textContent = variant.available ? atcLabel : atc.dataset.soldOut || atcLabel;
        }
      }
      if (updateImage) {
        const media = mediaFromVariant(mediaVariant, product);
        if (media) setMainImage(root, media.src, media.alt, media.id);
      }
    }

    function syncFromSelection() {
      syncVariantState(true);
    }

    function defaultToLargeIfNeeded() {
      if (!form || !product) return;
      try {
        if (new URLSearchParams(window.location.search).get('variant')) return;
      } catch (err) {
        /* ignore */
      }
      const sizeI = sizeOptionIndex(form);
      if (sizeI < 0) return;
      const colorI = colorOptionIndex(form);
      const opts = selectedOptions();
      const colorVal = colorI >= 0 ? opts[colorI] : '';
      const large = variantsForColor(colorVal).find((v) => isLargeSize(v.options[sizeI]) && v.available);
      if (!large) return;
      const largeVal = String(large.options[sizeI]);
      if (opts[sizeI] === largeVal) return;
      setOptionValue(sizeI, largeVal);
      syncFromSelection();
    }

    function onThumb(btn) {
      activateThumb(root, btn);
      selectColorFromThumb(btn);
    }

    thumbs.forEach((btn, index) => {
      btn.addEventListener('click', () => onThumb(btn));
      btn.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          next = thumbs[(index + 1) % thumbs.length];
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          next = thumbs[(index - 1 + thumbs.length) % thumbs.length];
        } else if (event.key === 'Home') {
          next = thumbs[0];
        } else if (event.key === 'End') {
          next = thumbs[thumbs.length - 1];
        }
        if (next) {
          event.preventDefault();
          next.focus();
          onThumb(next);
        }
      });
    });

    if (!form || !product) return;

    form.addEventListener('change', (event) => {
      const fieldset = event.target && event.target.closest ? event.target.closest('[data-option]') : null;
      if (fieldset && isColorOptionName(fieldset.getAttribute('data-option-name'))) {
        ensureSizeForSelectedColor();
      }
      syncFromSelection();
    });

    defaultToLargeIfNeeded();
  });

  document.addEventListener('cart:updated', () => {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        qsa('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(() => {});
  });

  qsa('.product-card__form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const btn = qs('[type="submit"]', form);
      const original = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = btn.dataset.loading || original;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form)).toString()
      })
        .then((res) => {
          if (!res.ok) throw new Error('cart');
          return res.json();
        })
        .then(() => {
          if (btn) btn.textContent = btn.dataset.added || original;
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(() => {
            if (btn) {
              btn.textContent = original;
              btn.disabled = false;
            }
          }, 1600);
        })
        .catch(() => {
          if (btn) {
            btn.textContent = original;
            btn.disabled = false;
          }
        });
    });
  });
})();
